import styled from "styled-components";

export const Text = styled.p`
  text-align: center;
`;

export const Span = styled.span`
  color: #9557e8;
`;
